import { render } from "./welcomeBanner.vue?vue&type=template&id=d3e8d7e2&scoped=true"
import script from "./welcomeBanner.vue?vue&type=script&lang=js"
export * from "./welcomeBanner.vue?vue&type=script&lang=js"

import "./welcomeBanner.vue?vue&type=style&index=0&id=d3e8d7e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3e8d7e2"]])

export default __exports__